module.exports = __webpack_public_path__ + "media/components/src/assets/images/photo/remove_red_eye-b42dd4be680b1b201e1bc24676c4b42e.png";